import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const FOCUS_KEY = 'editButtonSearch_shouldFocus';

const EditButtonSearch = ({ placeholder, value: propValue, onChange, disabled }) => {
  const [value, setValue] = useState(propValue || '');
  const inputRef = useRef(null);
  const componentId = useRef(placeholder);

  useEffect(() => {
    setValue(propValue || '');
  }, [propValue]);

  useEffect(() => {
    const storedId = sessionStorage.getItem(FOCUS_KEY);
    const isDisabled = inputRef.current ? inputRef.current.disabled : false;

    if (storedId === componentId.current && inputRef.current && !isDisabled) {
      inputRef.current.focus();

      setTimeout(() => {
        if (document.activeElement === inputRef.current && !inputRef.current.disabled) {
          sessionStorage.removeItem(FOCUS_KEY);
        }
      }, 100);
    }
  });

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
  };

  const handleSearch = () => {
    sessionStorage.setItem(FOCUS_KEY, componentId.current);
    onChange(value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      handleSearch();
    }
  };

  return (
    <div className='u-flex u-flex-gap'>
      <input
        ref={inputRef}
        className='u-margin-bottom--zero'
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
      <button className='o-sp-button o-sp-button--search' onClick={handleSearch}>
        <i className='sp-icon-search o-search__icon'></i>
      </button>
    </div>
  );
};

EditButtonSearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default EditButtonSearch;
